import { RecordedCallKey } from 'flow/types/EntityKeys';
import { TranscriptionState } from 'flow/types/RecordedCalls';
import { State } from 'flow/types/State';

export const selectTranscriptionProgress = (
    state: State,
    recordingKey: RecordedCallKey,
): TranscriptionState | undefined => {
    return state.recordedCalls.getIn(['transcriptionProgress', recordingKey]);
};
